import { render, staticRenderFns } from "./ModelViewerHeader.vue?vue&type=template&id=5d37bcdb&scoped=true"
import script from "./ModelViewerHeader.vue?vue&type=script&lang=ts"
export * from "./ModelViewerHeader.vue?vue&type=script&lang=ts"
import style0 from "./ModelViewerHeader.vue?vue&type=style&index=0&id=5d37bcdb&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d37bcdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d37bcdb')) {
      api.createRecord('5d37bcdb', component.options)
    } else {
      api.reload('5d37bcdb', component.options)
    }
    module.hot.accept("./ModelViewerHeader.vue?vue&type=template&id=5d37bcdb&scoped=true", function () {
      api.rerender('5d37bcdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/ModelViewerHeader.vue"
export default component.exports